import { render, staticRenderFns } from "./OrdersGrid.vue?vue&type=template&id=d94cd686&"
import script from "./OrdersGrid.vue?vue&type=script&lang=js&"
export * from "./OrdersGrid.vue?vue&type=script&lang=js&"
import style0 from "./OrdersGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports